import { CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { httpMethods } from 'enums';
import { Http } from 'library';
// import { EntUserPool, UserPool } from './UserPool';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';

/* eslint-disable */
class SignUpService {
  static sendNewOtp = async (data: any, token: any = '') =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.SEND_NEW_OTP}`)
      .setToken(token)
      .request();

  static verifyNewOtp = async (data: any, token: any = '') =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.VERIFY_NEW_OTP}`)
      .setToken(token)
      .request();

  static createCustomerDetails = async (data: any, token: any) =>
    Http.setMethod(httpMethods.post)
      .setData(data)
      .setUrl(`${Endpoints.UPDATE_USER_DETAILS}`)
      .setToken(token)
      .request();

  static isValidReferralCode = async (code) =>
    Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.IS_VALID_REFCODE}?referralCode=${code}`)
      .request();
}

export default SignUpService;
